import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthenticationService } from '@stockaid/services';

@Injectable({
  providedIn: 'root',
})
export class AscV2Service {
  private readonly url = '/api/asc';

  constructor(private http: HttpClient, private authService: AuthenticationService) {}

  calculateLostSales(body: {company_id: string; user_id: string}) {
    return this.http.post<{user_id: string, company_id: string}>(`${this.url}/calculate-lost-sale`, body);
  }

  syncPricingListMaxMin(company_id: string) {
    return this.http.post<{status: string}>(`${this.url}/sync-pricing-list-max-min`, { company_id, user_id: this.getUserId() });
  }

  private getUserId(): string {
    return this.authService.currentUser?.userId || 'unknown';
  }
}
